import { render } from "./MessageReaction.vue?vue&type=template&id=2781c512&ts=true"
import script from "./MessageReactions.ts?vue&type=script&lang=ts&external"
export * from "./MessageReactions.ts?vue&type=script&lang=ts&external"

import "./MessageReactions.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__